import { render, staticRenderFns } from "./MappingConfiguration.vue?vue&type=template&id=a2bb7e30&"
import script from "./MappingConfiguration.vue?vue&type=script&lang=ts&"
export * from "./MappingConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports